import { Component, OnInit, effect, inject, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { DashboardsService } from '@fry/dashboards/lib/dashboards.service';
import { UserService } from '@fry/lib/users';

@Component({
    selector: 'eas-user-dashboard',
    templateUrl: './user-dashboard.component.html',
    providers: [UserService, DashboardsService],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UserDashboardComponent implements OnInit {

  dashboadsService = inject(DashboardsService);
  userService = inject(UserService);
  route = inject(ActivatedRoute);

  selectDashboardControl = new FormControl('');

  $selectedDashboard = this.dashboadsService.$selectedDashboard;
  $availableDashboards = this.dashboadsService.$availableDashboards;

  public selectedDashboardId: string = '';

  constructor() {
    effect(() => {
      const value = this.$selectedDashboard().dashboard?.doc._id;
      if (value !== undefined && this.selectDashboardControl.value !== value) {
        this.selectDashboardControl.setValue(value);
      }
    });
    this.selectDashboardControl.valueChanges.pipe(
      takeUntilDestroyed()
    ).subscribe((value) => {
      if (value !== null) {
        this.dashboadsService.setDashboard(value);
      }
    });
  }

  ngOnInit() {
    this.route.data.subscribe(data => {
      this.userService.setUser(data.user);
      this.dashboadsService.loadSummariesFor(data.user).subscribe();
    });
  }
}
